import config from "console_config";

/**
 * Builds a support URL with the correct base, path, and query parameters.
 * Automatically appends the cloud vendor tag when configured.
 */
export function buildSupportUrl(
  path?: string,
  params?: Record<string, string>
): string {
  try {
    const base = config.ZENDESK_BASE_URL;
    const url = new URL(path ? `${base}/${path}` : base);

    if (config.ZENDESK_CLOUD_TAG) {
      url.searchParams.set("cloud", config.ZENDESK_CLOUD_TAG);
    }

    if (params) {
      for (const [key, value] of Object.entries(params)) {
        url.searchParams.set(key, value);
      }
    }

    return url.toString();
  } catch {
    return config.ZENDESK_BASE_URL;
  }
}
